import { Colors, Lightning } from '@lightningjs/sdk';
import { getFontFaceFromStyle } from 'support/textUtils';
import AbstractContinueTile, {
  ContinueTileTemplateSpec,
} from 'components/common/tiles/AbstractContinueTile';
import TextLabel from '../TextLabel';

const TILE_WIDTH = 400;
const TILE_HEIGHT = 313;

const TILE_HIGHLIGHT_WIDTH = TILE_WIDTH;
const TILE_HIGHLIGHT_HEIGHT = 225;

const TITLE_TEXT_FONT_SIZE = 24;
const TITLE_TEXT_HEIGHT = 31;

const TEXT_CONTAINER_Y = TILE_HIGHLIGHT_HEIGHT + 15;
const TEXT_FONT_SIZE = 20;
const TEXT_MAX_LINES = 1;

export default class MyStuffContinueTile extends AbstractContinueTile {
  override tileWidth = TILE_WIDTH;
  override tileHeight = TILE_HEIGHT;
  override tileHighlightWidth = TILE_HIGHLIGHT_WIDTH;
  override tileHighlightHeight = TILE_HIGHLIGHT_HEIGHT;

  static override get width() {
    return TILE_WIDTH;
  }

  static override get height() {
    return TILE_HEIGHT;
  }

  static override get highlightWidth() {
    return TILE_HIGHLIGHT_WIDTH;
  }

  static override get highlightHeight() {
    return TILE_HIGHLIGHT_HEIGHT;
  }

  static override _template(): Lightning.Component.Template<ContinueTileTemplateSpec> {
    return {
      ...super._template(),
      TextContainer: {
        y: TEXT_CONTAINER_Y,
        flex: { direction: 'column' },
        Title: {
          type: TextLabel,
          w: TILE_WIDTH,
          h: TITLE_TEXT_HEIGHT,
          text: {
            fontFace: getFontFaceFromStyle('bold'),
            fontSize: TITLE_TEXT_FONT_SIZE,
            maxLines: TEXT_MAX_LINES,
            textColor: Colors('text').get(),
            h: TITLE_TEXT_HEIGHT,
          },
        },
        SeasonEpisode: {
          type: TextLabel,
          text: {
            fontSize: TEXT_FONT_SIZE,
            textColor: Colors('text').get(),
          },
        },
      },
    };
  }

  override showDecoration(enabled: boolean) {
    this._PlayButton.patch({ visible: !enabled });
    this._Badge.patch({ visible: !enabled });

    if (this.shouldShowProgressBar()) {
      this._ProgressBar.patch({ visible: !enabled });
    }
  }
}
